import "../build/ckeditor" // Needed for CKEditor styling
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import SanitizedHtml from "shared/sanitized-html"
import {StyleSheet} from "react-native"
import {useDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

/**
 * @typedef {object} CkeditorPresentationProps
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} html
 * @property {unknown} style
 */

/** @typedef {object} CkeditorPresentationState */

/**
 * @extends {ShapeComponent<CkeditorPresentationProps, CkeditorPresentationState>}
 */
class CkeditorPresentation extends ShapeComponent {
  static propTypes = {
    className: PropTypes.string,
    html: PropTypes.string.isRequired
  }

  setup() {
    this.defaultStyle = useDefaultStyle()
  }

  render() {
    const {children, className, html, style, ...restProps} = this.props
    const defaultStyle = this.tt.defaultStyle
    const defaultTextStyle = useMemo(
      () => StyleSheet.flatten(defaultStyle?.Text),
      [defaultStyle?.Text]
    )
    const actualStyle = useMemo(
      () => StyleSheet.flatten([defaultTextStyle, style]),
      [defaultTextStyle, style]
    )

    if (children && children.length > 0) {
      throw new Error("Children are not supported")
    }

    return (
      <SanitizedHtml
        className={classNames("components--ckeditor--presentation", className)}
        html={this.actualHtml()}
        style={actualStyle}
        {...restProps}
      />
    )
  }

  actualHtml() {
    const {html} = this.p

    if (html) {
      return `<div class='ck-content'>${html}</div>`
    } else {
      return ""
    }
  }
}

export default memo(shapeComponent(CkeditorPresentation))
